import React, {Component} from "react"
import styles from "./Navigation.module.css"
import classNames from "classnames"
import {FormID} from "interfaces"
import {observer} from "mobx-react"
import {Item} from "./parts/Item"
import {observable} from "mobx"
import {Model} from "Model"

interface Props {
    checkedItems: FormID[]
    enabledItems: FormID[]
    selected: FormID
    onChange: (form_id: FormID) => void
    mode: "mobile" | "tablet" | "desktop"
    className?: string
    model: Model
    isDrawer?: boolean
}

@observer
export class Navigation extends Component<Props, {}> {
    @observable
    private openedTab: string = null

    public componentDidMount(): void {
        if (this.props.mode === "desktop" || this.props.isDrawer) {
            this.openedTab = this.getTabIdByFormId(this.props.selected)
        } else {
            this.openedTab = null
        }
    }

    public componentDidUpdate(prevProps: Props) {
        if (this.props.selected === prevProps.selected) {
            return
        }

        if (this.props.mode === "desktop" || this.props.isDrawer) {
            this.openedTab = this.getTabIdByFormId(this.props.selected)
        } else {
            this.openedTab = null
        }
    }

    private getTabIdByFormId(form_id: FormID): string {
        const tabs = this.props.model.getTabs()
        for (const tab of tabs) {
            const hasForm = tab.items.find((el) => {
                if (el.value === form_id) {
                    return true
                }
                return false
            })
            if (hasForm) {
                return tab.id
            }
        }

        return null
    }

    public render() {
        const {selected, onChange, className} = this.props
        const tabs = this.props.model.getTabs()

        const currentTabId = this.getTabIdByFormId(selected)

        const isDrawer = Boolean(this.props.isDrawer)

        return (
            <div className={classNames(styles.root, isDrawer && styles.drawerRoot, className)}>
                <ul className={classNames(styles.list, isDrawer && styles.drawerList)}>
                    {tabs.map((el, index) => {
                        const stepNum = index + 1
                        let subtitle = ""
                        if (el.id === "1" || el.tab_id === "career_information") {
                            subtitle = "Program, campus, shifts, term & advisor"
                        } else if (el.id === "4" || el.tab_id === "forms") {
                            subtitle = "Disclosures, enrollments & releases"
                        } else if (el.id === "5" || el.tab_id === "upload_docs") {
                            subtitle = "Government ID, diploma or GED"
                        } else if (el.id === "6" || el.tab_id === "submission") {
                            subtitle = "Official digital signature & certification"
                        }

                        return (
                            <Item
                                key={el.id}
                                id={el.id}
                                title={el.title}
                                tabletTitle={el.tabletTitle}
                                items={el.items as any}
                                onTitleClick={(tab_id) => {
                                    this.openedTab = this.openedTab === tab_id ? null : tab_id
                                }}
                                onClick={(id: FormID) => {
                                    if (this.props.mode !== "desktop" && !isDrawer) {
                                        this.openedTab = null
                                    }
                                    onChange(id)
                                }}
                                selected={selected}
                                checkedItems={this.props.checkedItems}
                                enabledItems={this.props.enabledItems}
                                isOpen={this.openedTab === el.id}
                                disableTab={el.disabled}
                                stepNumber={stepNum}
                                subtitle={subtitle}
                                badgeText=""
                                isCurrent={currentTabId === el.id}
                                isDrawer={isDrawer}
                            />
                        )
                    })}
                </ul>
            </div>
        )
    }
}
